/* 项目列表相关接口 */
import http from "./request";

// 获取项目列表分页
export function getProjectsList(params) {
	return http(`/project/page`, {
		method: "POST",
		params
	});
}

// 查询各种状态数量
export function getStatusCount(params) {
	return http(`/project/esProjectSize`, {
		method: "POST",
		params
	});
}

// 删除项目列表
export function deleteProject(id) {
	return http(`/project/del/${id}`, {
		method: "DELETE",
		params: {}
	});
}

// 获取项目详情
export function getProjectDetail(params) {
	return http(`/project/detail`, {
		method: "POST",
		params
	});
}
